import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';

export abstract class BaseComponent
{
    public static readonly BaseImports = [
        CommonModule,
        RouterLink,
        RouterLinkActive
    ];
}
